export default __webpack_public_path__ + "static/ForegroundImage-f1bcf573aad89628082b85452faed23e.png";